import { Box, Popover, IconButton, Tooltip } from "@material-ui/core";
import React, { useRef, useState } from "react";
import { get } from "lodash";
import useStyles from "./styles";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import { useTranslation } from "react-i18next";
import EmojiIcon from "Assets/images/message-icons/emoji.svg";

const EmojiPicker = ({ comment, setComment, addEmoji }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [emojiPickerState, SetEmojiPicker] = useState(false);
  let emojiPicker;

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    SetEmojiPicker(false);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const containerRef = useRef();

  if (emojiPickerState) {
    emojiPicker = (
      <Picker
        title={t("visionBoard.pickEmoji")}
        emoji={t("visionBoard.pointUp")}
        onSelect={emoji => {
          setComment && setComment(comment + emoji.native);
          addEmoji && addEmoji(emoji.native);
          handleClose();
        }}
      />
    );
  }
  const triggerPicker = event => {
    event.preventDefault();
    SetEmojiPicker(!emojiPickerState);
  };
  return (
    <>
      <Box data-testid="handleClick" onClick={handleClick}>
        <Tooltip title="Emoji">
          <IconButton
            data-testid="triggerPicker"
            aria-label="delete"
            color="primary"
            onClick={triggerPicker}
            className={classes.emojiPicker}>
            <img src={EmojiIcon} />
          </IconButton>
        </Tooltip>
      </Box>
      <Popover
        container={get(containerRef, "current", "")}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center"
        }}>
        <Box display="flex" alignItems="center" mx={2} my={2}>
          {emojiPicker}
        </Box>
      </Popover>
    </>
  );
};

export default EmojiPicker;
